import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';

@Injectable()
export class RequestUtils {
  constructor(private configService: ConfigService) {}

  isOurDomain(request: HttpRequest<any>) {
    return (
      !(request.url.includes('http://') || request.url.includes('https://')) ||
      request.url.startsWith(this.configService.getValue('BASE_URL'))
    );
  }
}
